import InfoNotification from '@src/components/Notifications/InfoNotification';
import {ServerNotificationProps} from '@src/components/Notifications/server-notifications/ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import {getProductionDashboardUrlIfPossible} from '../getProductionDashboardUrlIfPossible';
import {
    getManagerDashboardProductsListSearchParams
} from '@src/components/Notifications/server-notifications/Order/Product/getManagerDashboardProductsListSearchParams';
import {
    getSearchTermParams
} from '@src/components/Notifications/server-notifications/Order/Product/getSearchTermParams';
import getUri from '@src/helpers/getUri';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';

export default class FileUploaded extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\Product\\File\\FileUploaded'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        const getSearchParams = (params: Record<string, string>) => {
            return getSearchTermParams('OrderProducts', String(payload.orderId), params);
        };

        const to: { url: string | null, searchParams: Record<string, any> } = {
            url: null,
            searchParams: {},
        };

        to.url = getProductionDashboardUrlIfPossible(payload.orderProductId);
        if (to.url && payload.orderProductId) {
            to.searchParams = getSearchParams({productId: String(payload.orderProductId)});
        } else if (!payload.orderProductId) {
            to.url = null;
        }

        if (!to.url) {
            to.url = getUri({
                route: namesResolver.getShowRouteName('Orders'),
                params: {id: String(payload.orderId)},
            });
            to.searchParams = getSearchParams({productCode: String(payload.orderProductCode)});
        }

        to.searchParams = {
            ...to.searchParams,
            ...getSearchParams(
                    getManagerDashboardProductsListSearchParams({
                        fileId: String(payload.file.id),
                    })
            ),
        };

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                url: to.url,
                searchParams: to.searchParams,
                hash: '#OrdersShow.tabs.products'
            }),
        };
    }

    protected getDescriptionReplacements() {
        const data = this.props.notification.data;

        return {
            ...data,
            ...data.file,
            name: data.file?.file?.public_name ?? data.file?.file?.file_name ?? data.file_name ?? 'unknown',
        };
    }
}
